import i18next from "i18next";
import React, {useEffect, useRef, useState} from "react";
import ReactHtmlParser from "react-html-parser";


export function trans(key, replace = {}) {
    let translation = i18next.t(key);

    for (let placeholder in replace) {
        if (placeholder && replace && translation) {
            translation = translation.replace(`:${placeholder}`, replace[placeholder]);
        }
    }

    return ReactHtmlParser(translation);
}

export const onresize = (dom_elem, callback) => {
    const resizeObserver = new ResizeObserver(() => callback());
    resizeObserver.observe(dom_elem);
};

export const DynamicImportSvg = (props) => {
    const ImportedIconRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const {name} = props;
    useEffect(() => {
        setLoading(true);

        const importIcon = async () => {
            try {
                const {default: namedImport} = await import('../assets/images/svg/' + name + '.svg');
                ImportedIconRef.current = namedImport;
            } catch (err) {
                //throw err;
            } finally {
                setLoading(false);
            }
        };
        importIcon();
    }, [name]);

    if (!loading && ImportedIconRef?.current) {
        const {current: ImportedIcon} = ImportedIconRef;
        if (ImportedIcon) {
            return (
                <img
                    alt={''}
                    className={props?.className}
                    src={ImportedIcon} onError={(e) => {
                    //console.log('e', e)
                }}
                    onClick={props?.onClick}
                />
            );
        }
    }

    return null;
};

export function scrollbarRenderThumb({style, ...props}) {
    const {top} = props;
    const thumbStyle = {
        backgroundColor: `rgb(${Math.round(255 - (top * 255))}, ${Math.round(255 - (top * 255))}, ${Math.round(255 - (top * 255))})`
    };
    return (
        <div style={{...style, ...thumbStyle}} {...props}/>
    );
}


